import React from "react";

const Button = ({ block }) => {
  var link = "/";
  // Entry Link first, if not available, fall back to custom URL
  link = !block.entryLink.length ? block.customUrl : block.entryLink[0].url;

  return (
    <section>
      <div className={`shell flex justify-${block.position}`}>
        <a href={link} className="section__btn btn btn--green js-load-more-btn ml-2 mb-2">{block.buttonText}</a>
      </div>
    </section>
  );
}

export default Button;